if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        // Fonction pour trouver l'élément parent avec la classe 'section--collapsible-tabs'
        const findParentSection = (element) => {
          let parent = element.parentElement;
          while (parent) {
            if (parent.classList.contains('section--collapsible-tabs')) {
              return parent;
            }
            parent = parent.parentElement;
          }
          return null;
        };

        // Vérifier si l'élément parent a la classe 'first-opened'
        const parentSection = findParentSection(this);
        if (parentSection && parentSection.classList.contains('first-opened') && this.detailsElements.length > 0) {
          this.detailsElements[0].open = true;
          this.handleOpen(this.detailsElements[0]);
        }

        this.detailsElements.forEach((details) => {
          details.open ? this.handleOpen(details) : this.handleClose(details);
          details.addEventListener('toggle', this.onToggle.bind(this));
        });
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );
}
